import { render, staticRenderFns } from "./ProjectsPanel.vue?vue&type=template&id=64ce3bba&scoped=true&"
import script from "./ProjectsPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsPanel.vue?vue&type=style&index=0&id=64ce3bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce3bba",
  null
  
)

export default component.exports